import {
    GET_ICONS,
    GET_STATE_LOADING_ICONS
} from "@/shared/components/icons_selector/store/types/types.js";

const getters = {
    [GET_ICONS]: state => state.icons_list,
    [GET_STATE_LOADING_ICONS]: state => state.loading
};

export default getters;